import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApsService, CompanyService } from "src/app/services";
import { WebCompany, WebContractLetter } from "../../../models";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";

@Component({
  templateUrl: "./make-a-payment-dialog.component.html",
  styleUrls: ["./make-a-payment-dialog.component.scss"]
})
export class MakeAPaymentDialogComponent implements OnInit, OnDestroy
{

  @Input() prebuy: boolean;
  @Input() contractTotal: number;
  @Input() contractsAdded: WebContractLetter[];

  private companySubscription: Subscription;
  public company: WebCompany;
  cODOrderAmount: number;
  isPaymentForCODDelivery: boolean;



  constructor(
    public dialogRef: MatDialogRef<MakeAPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public apsService: ApsService,
    private companyService: CompanyService) { }

  ngOnInit(): void
  {

    this.companySubscription = this.companyService.company.subscribe(c => this.company = c);
    this.cODOrderAmount = this.data?.totalAmount > 0 ? this.data.totalAmount : 0;
    this.isPaymentForCODDelivery = this.data?.isPaymentForCODDelivery ? this.data.isPaymentForCODDelivery : false;
  }

  ngOnDestroy(): void
  {
    this.companySubscription.unsubscribe();
  }

  public handleClose(): void
  {
    this.dialogRef.close();
  }

}
